import type { PhosphorIconName } from "@/shared/components/common/PhosphorIcon";

export type HotelResultsV2Room = {
  id: string;
  roomId?: string;
  title: string;
  ratePlanId?: string;
  ratePlanName?: string;
  image: string;
  capacity: number;
  extraCapacity?: number;
  hasBreakfast: boolean;
  mealType?: string;
  mealLabel?: string;
  freeCancellation: boolean;
  price: number;
  totalPrice?: number;
  inventory?: number;
  reservationState?: string;
  minStay?: number | null;
  maxStay?: number | null;
  freeChildCount?: number;
  freeChildAgeUpTo?: number;
  source: "existed_rooms" | "min_price_rooms" | "dev_fallback";
};

export type HotelResultsV2AmenityItem = {
  key: string;
  label: string;
  icon: PhosphorIconName;
  isImportant?: boolean;
  isOffer?: boolean;
};

export type HotelResultsV2OfferItem = HotelResultsV2AmenityItem;

export type HotelResultsV2Item = {
  id: string;
  name: string;
  href?: string;
  cityCode?: string;
  slug?: string;
  stars: number;
  score?: number;
  reviewCount?: number;
  location: string;
  description?: string;
  accommodationKey?: string;
  tags: string[];
  amenities: {
    wifi: boolean;
    parking: boolean;
    pool: boolean;
    restaurant: boolean;
    ac: boolean;
    elevator: boolean;
    gym?: boolean;
    spa?: boolean;
  };
  amenityItems: HotelResultsV2AmenityItem[];
  offerItems: HotelResultsV2OfferItem[];
  hasAmenities: boolean;
  hasBreakfast: boolean;
  freeCancellation?: boolean;
  mealPlans: string[];
  hasCapacity: boolean;
  pricePerNight?: number;
  originalPrice?: number;
  priceStatus: "cached" | "verifying" | "verified";
  lastUpdated?: string;
  images: string[];
  rooms: HotelResultsV2Room[];
  isAvailable?: boolean;
  isFeatured?: boolean;
  isPopular?: boolean;
  isLuxury?: boolean;
  isFamilyFriendly?: boolean;
  isBusiness?: boolean;
};

export type HotelResultsV2Filters = {
  minPrice: number;
  maxPrice: number;
  stars: number[];
  breakfast: boolean;
  freeCancellation: boolean;
  pool: boolean;
  parking: boolean;
  wifi: boolean;
  restaurant: boolean;
  gym: boolean;
  spa: boolean;
  amenities: string[];
  offers: string[];
  minScore: number;
  isLuxury: boolean;
  isFamilyFriendly: boolean;
  isBusiness: boolean;
  isPopular: boolean;
  hotelName: string;
  mealPlan: string[];
  areas: string[];
};

export const HOTEL_RESULTS_V2_PRICE_MIN = 1_450_000;
export const HOTEL_RESULTS_V2_PRICE_MAX = 5_500_000;

export const HOTEL_RESULTS_V2_DEFAULT_FILTERS: HotelResultsV2Filters = {
  minPrice: HOTEL_RESULTS_V2_PRICE_MIN,
  maxPrice: HOTEL_RESULTS_V2_PRICE_MAX,
  stars: [],
  breakfast: false,
  freeCancellation: false,
  pool: false,
  parking: false,
  wifi: false,
  restaurant: false,
  gym: false,
  spa: false,
  amenities: [],
  offers: [],
  minScore: 0,
  isLuxury: false,
  isFamilyFriendly: false,
  isBusiness: false,
  isPopular: false,
  hotelName: "",
  mealPlan: [],
  areas: [],
};
